let loadedScripts={};
let loadingScriptsCallbacks={};
let funs = {
    requireJs: function(scripts, callback) {
        function load(url, callback) {
            if (loadedScripts[url]) return setTimeout(function() {
                callback.call(this, true)
            }, 0);
            if (loadingScriptsCallbacks[url]) {
              loadingScriptsCallbacks[url].push(callback);
              return;
            }
            loadingScriptsCallbacks[url]=[callback];
            function invokeCallback(r){
              if(loadingScriptsCallbacks[url]){
                loadingScriptsCallbacks[url].forEach(c=>{
                  c(r)
                });
                loadingScriptsCallbacks[url]=undefined;
              }
            }
            var script = document.createElement('script');
            script.type = 'text/javascript';
            //加载数据失败的时候
            var onErrorFn = function() {
                //callback.call(this, false);
              invokeCallback(false);
            };
            var onLoadFn = function() {
                loadedScripts[url] = true;
                invokeCallback(true);
                //callback.call(this, true);
            };
            script.onerror = onErrorFn;
            if ('addEventListener' in script) {
                script.onload = onLoadFn;
            } else if ('readyState' in script) {
                script.onreadystatechange = function() {
                    if (this.readyState == 'loaded' || this.readyState == 'complete') {
                        onLoadFn();
                    }
                };
            } else {
                script.onload = onLoadFn;
            }
            script.src = url;
            document.getElementsByTagName('head')[0].appendChild(script);
            return script;
        }

        if (!$.isArray(scripts)) scripts = scripts.split(",")
        var ubound = scripts.length - 1,
            cursor = 0;
        doLoad();

        function doLoad() {
            if (cursor <= ubound) {
                load(scripts[cursor], function() {
                    cursor++;
                    doLoad();
                });
            } else {
                callback();
            }
        }
    },
    loadCss: function(url) {
        let me = this;
        if ($.isArray(url)) {
            url.forEach(function(u) {
                me.loadCss(u)
            })
            return;
        }
        if (!loadedScripts[url]) {
            $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', url));
            loadedScripts[url] = true;
        }
    }
}
export default funs;



// WEBPACK FOOTER //
// ./src/common/components/utils/scriptLoader.js